export default __webpack_public_path__ + "643ab7dfe8e8e538bc7029a434296a41.svg";